import React from 'react'
import PropTypes from 'prop-types'
import MagicLinkValidateTemplate from '../../templates/MagicLinkValidateTemplate'

export const MagicLinkValidatePage = props => {
  const {
    token,
    onSuccess,
    onError,
    onPhoneNotValidated,
    onChallengePinCodeCall,
    onAccountNotValidated,
    onAccountMustValidate,
    abTests,
    onAccountCompleteData,
  } = props

  return (
    <MagicLinkValidateTemplate
      onSuccess={onSuccess}
      onError={onError}
      token={token}
      onPhoneNotValidated={onPhoneNotValidated}
      onChallengePinCodeCall={onChallengePinCodeCall}
      onAccountNotValidated={onAccountNotValidated}
      onAccountMustValidate={onAccountMustValidate}
      abTests={abTests}
      onAccountCompleteData={onAccountCompleteData}
    />
  )
}

MagicLinkValidatePage.propTypes = {
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  onPhoneNotValidated: PropTypes.func,
  token: PropTypes.string,
  onAccountNotValidated: PropTypes.func,
  abTests: PropTypes.string,
  onAccountCompleteData: PropTypes.func,
}
